// © 2015-2021 WDNA - All Rights Reserved
import { HighChartOptions } from 'wdna-highchart';

export const CARDINALS: string[] = [
  'N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'
];

const line: HighChartOptions = {
  time: {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  title: {
    text: undefined,
    style: {
      color: '#fff',
    },
  },
  subtitle: {
    text: '',
    style: {
      color: '#fff',
    },
  },
  tooltip: {
    xDateFormat: '%Y-%m-%d %H:%M:%S',
    shared: true,
    // crosshairs: true,
  },
  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
  },
  lang: {
    noData: 'No data available to graph.',
  },
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '18px',
      color: '#fff',
    },
  },
  xAxis: [
    {
      tickmarkPlacement: 'on',
      title: {
        text: 'DATES',
        style: {},
      },
      type: 'datetime',
      labels: {
        format: '{value:%Y-%m-%d %H:%M}',
        rotation: -45,
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      tickAmount: undefined,
      gridLineWidth: 0,
      crosshair: false,
    },
  ],
  yAxis: [
    {
      title: {
        text: null,
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      labels: {
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      gridLineColor: 'rgba(255,255,255,1)',
      crosshair: false,
      tickAmount: 5,
      plotLines: undefined,
    },
    {
      title: {
        text: null,
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      labels: {
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      min: 0,
      gridLineColor: 'rgba(255,255,255,1)',
      crosshair: false,
      tickAmount: 5,
      plotLines: undefined,
      opposite: true,
    },
  ],
  plotOptions: {
    series: {
      cursor: 'pointer',
      marker: {
        lineWidth: 1,
      },
    },
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: false,
      },
      borderWidth: 1,
      borderRadius: 2,
      pointPadding: 0.2,
      shadow: true,
      pointWidth: 20,
    },
    line: {
      enableMouseTracking: true,
      allowPointSelect: true,
      marker: {
        enabled: true,
      },
      zIndex: -1,
    },
  },
  exporting: {
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        symbolStroke: '#fff',
        theme: {
          stroke: undefined,
          /*
          states: {
            hover: {
              fill: 'rgba(18, 47, 51, 0.2)',
              stroke: '#fff',
            },
            select: {
              fill: 'rgba(18, 47, 51, 0.2)',
              stroke: 'rgba(255, 255, 255, 0.2)',
            },
          },
          */
        },
      },
    },
  },
  chart: {
    type: 'line',
    zoomType: 'xy',
    height: '50%',
    backgroundColor: undefined,
    resetZoomButton: {
      position: {
        x: 0,
        y: -50,
      },
    },
  },
  series: [],
};

const gaugeSimple: HighChartOptions = {
  chart: {
    type: 'solidgauge',
    height: '80%',
    spacingTop: 0,
    backgroundColor: undefined,
  },

  title: {
    text: undefined,
    style: {
      color: '#fff',
    }
  },

  pane: {
    center: ['50%', '45%'],
    size: '85%',
    startAngle: -130,
    endAngle: 130,
    background: [{
      backgroundColor: undefined,
      innerRadius: '60%',
      outerRadius: '100%',
      shape: 'arc'
    }]
  },

  exporting: {
    enabled: false
  },

  tooltip: {
    enabled: true,
    style: {
      color: '#fff',
    },
    valueSuffix: undefined
  },

  // the value axis
  yAxis: {
    min: null,
    max: null,
    title: {
      text: null,
      y: -70
    },
    stops: [
      [0.1, '#55BF3B'], // green
      [0.5, '#DDDF0D'], // yellow
      [0.9, '#DF5353'] // red
    ],
    lineWidth: 10,
    tickAmount: 3,
    labels: {
      y: 22,
    }
  },
  plotOptions: {
    solidgauge: {
      dataLabels: {
        y: 5,
        borderWidth: 0,
        color: '#fff'
      }
    }
  }
};

const gauge: HighChartOptions = {
  chart: {
    type: 'solidgauge',
    height: '80%',
    spacingTop: 0,
    backgroundColor: undefined,
  },
  title: {
    text: undefined,
    style: {
      color: '#fff',
    }
  },
  tooltip: {
    borderWidth: 0,
    backgroundColor: undefined,
    shadow: false,
    style: {
      fontSize: '16px',
      color: '#fff'
    },
    valueSuffix: '%',
    pointFormat:
      '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
    positioner: function positionerFunc(labelWidth: any) {
      return {
        x: ((this as any).chart.chartWidth - labelWidth) / 2,
        y: (this as any).chart.plotHeight / 2 + 15,
      };
    },
  },
  pane: {
    startAngle: 0,
    endAngle: 360,
    // background: {
    //   backgroundColor: null,
    // },
    background: [{ // Track for Move
      outerRadius: '112%',
      innerRadius: '88%',
      backgroundColor: '#5b5d5d',
      borderWidth: 0
    }, { // Track for Exercise
      outerRadius: '87%',
      innerRadius: '63%',
      backgroundColor: '#5b5d5d',
      borderWidth: 0
    }, { // Track for Stand
      outerRadius: '62%',
      innerRadius: '38%',
      backgroundColor: '#5b5d5d',
      borderWidth: 0
    }]
  },

  yAxis: {
    min: 0,
    max: 100,
    lineWidth: 0,
    tickPositions: [],
  },
  plotOptions: {
    solidgauge: {
      dataLabels: {
        enabled: false,
      },
      linecap: 'round',
      stickyTracking: false,
      rounded: true,
    },
  },
  series: [],
  exporting: { enabled: false },
};

const spline: HighChartOptions = {
  time: {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  title: line.title,
  subtitle: line.subtitle,
  legend: line.legend,
  lang: line.lang,
  noData: line.noData,
  xAxis: line.xAxis,
  yAxis: line.yAxis,
  exporting: line.exporting,
  chart: {
    type: 'spline',
    zoomType: 'xy',
    backgroundColor: undefined,
    style: {
      color: '#fff'
    },
    resetZoomButton: {
      position: {
        x: 0,
        y: -50,
      },
    },
  },
  tooltip: {
    shared: true,
    style: {
      color: '#fff',
    },
  },
  series: [],
};

const spline2: any = {
  title: {
    text: 'Accumulated Wind Direction',
    style: {
      color: '#fff',
    },
  },
  subtitle: {
    text: null,
    style: {
      color: '#fff',
    },
  },
  chart: {
    type: 'spline',
    zoomType: 'xy',
    height: '85%',
    backgroundColor: null,
    resetZoomButton: {
      position: {
        // align: 'right', // by default
        // verticalAlign: 'top', // by default
        x: 0,
        y: -50,
      },
    },
  },
  tooltip: {
    shared: true,
    crosshairs: true,
  },
  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    itemHoverStyle: {
      color: 'rgba(255,255,255,1)',
    },
  },
  xAxis: [
    {
      title: {
        text: null,
        style: {},
      },
      type: 'datetime',
      labels: {
        rotation: -60,
        format: '{value:%Y/%m/%d}',
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      tickAmount: undefined,
      gridLineWidth: 0,
      crosshair: false,
    },
  ],
  yAxis: [
    {
      title: {
        text: null,
        style: {},
      },
      labels: {
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      gridLineColor: 'rgba(255,255,255,1)',
      crosshair: false,
      tickAmount: 5,
      plotLines: null,
      reversedStacks: false,
    },
  ],
  plotOptions: {
    series: {
      cursor: 'pointer',
      borderWidth: 0,
      marker: {
        lineWidth: 1,
      },
    },
    column: {
      pointWidth: null,
    },
    line: {
      enableMouseTracking: false,
      allowPointSelect: false,
      marker: {
        enabled: false,
      },
      zIndex: -1,
    },
  },
  lang: {
    noData: 'There is no data for the graph',
  },
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '15px',
      color: '#fff',
    },
  },
  series: [],
  exporting: {
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        symbolStroke: '#fff',
        theme: {
          stroke: null,
          states: {
            hover: {
              fill: 'rgba(18, 47, 51, 0.2)',
              stroke: '#fff',
            },
            select: {
              fill: 'rgba(18, 47, 51, 0.2)',
              stroke: 'rgba(255, 255, 255, 1)',
            },
          },
        },
      },
    },
  },
};

const column: HighChartOptions = {
  title: {
    text: undefined,
    align: 'center',
    style: {
      whiteSpace: 'nowrap',
      color: '#fff',
      textOverflow: 'ellipsis'
    }
  },
  legend: line.legend,
  xAxis: {
    labels: {
      enabled: false
    },
  },
  yAxis: line.yAxis,
  exporting: {
    enabled: false
  },
  plotOptions: {
    column: {
      pointPadding: 0.3,
      borderWidth: 0
    }
  },
  chart: {
    type: 'column',
    inverted: false,
    backgroundColor: undefined,
  },
  tooltip: {
    shared: true,
    style: {
      color: '#fff',
    },
  },
  series: [],
};

const pressets: Record<string, HighChartOptions> = {
  line,
  spline,
  spline2,
  column,
  gaugeSimple,
  gauge,
};

export default pressets;
